import React, { useState } from "react";
import PropTypes from "prop-types";

const ModalBonus = ({
                      onCancel,
                      onSubmit
                    }) => {
  const [value, setValue] = useState(0);

  return (
    <div>
      <div className="form-group">
        <label>Add</label>
        <input
          className="form-control form-control-sm"
          type="number"
          value={value}
          onChange={ev => setValue(+ev.target.value)}
        />
      </div>
      <div className="text-right">
        <button
          className="btn btn-danger mr-2"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          className="btn btn-success"
          onClick={() => onSubmit(value)}
        >
          Save
        </button>
      </div>
    </div>
  );
};

ModalBonus.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default React.memo(ModalBonus);



// WEBPACK FOOTER //
// ./src/views/pages/users/modal-bonus.js